window.createCountDownTimer = (cmsStartTime,cmsEndTime) => {
  var month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      customStartDate = new Date(cmsStartTime),
      customEndTime = new Date(cmsEndTime);

  var startSecond = customStartDate.getSeconds().toString(),
      startMinute = customStartDate.getMinutes().toString();
  if(startSecond.length == 1){startSecond = '0'+startSecond;}
  if(startMinute.length == 1){startMinute = '0'+startMinute;}

  var endSecond = customEndTime.getSeconds().toString(),
      endMinute = customEndTime.getMinutes().toString();
  if(endSecond.length == 1){endSecond = '0'+endSecond;}
  if(endMinute.length == 1){endMinute = '0'+endMinute;}

  var startDate = new Date(`${customStartDate.getDate()} ${month[customStartDate.getMonth()]} ${customStartDate.getFullYear()} ${customStartDate.getHours() +':'+ startMinute +':'+ startSecond}`),
      endTime = new Date(`${customEndTime.getDate()} ${month[customEndTime.getMonth()]} ${customEndTime.getFullYear()} ${customEndTime.getHours() +':'+ endMinute +':'+ endSecond}`);

  var currentTime = new Date().getTime();
  var distance = endTime.getTime() - currentTime
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var isFinished = false,
      timeStart = false;


  if(currentTime >= startDate.getTime()){
    timeStart = true;
  }

  if(currentTime > endTime){
    isFinished =  true;
  }
  var data = {days:days,hours:hours,minutes:minutes,seconds:seconds,isFinished:isFinished,timeStart:timeStart};
  return data;
}

//   window.createCountDownTimer(`29 Oct 21 7:00:00 pm`,`29 Oct 21 8:00:00 pm`);


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if(model.modelViewerUI){
      model.modelViewerUI.pause()
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value,
          maxValue = this.input.dataset.maxValue;

    event.target.name === 'plus' ? ((previousValue != maxValue)?this.input.stepUp():false)
    : 
    this.input.stepDown();
    
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    //For Quickview Submit Btn
    var submitBtn = document.querySelector(".product-form__buttons .product-form__submit[type='submit']");
    if(submitBtn && submitBtn.hasAttribute("data-quantity")){
      var qty = document.querySelector(".quantity .quantity__input").value;
      submitBtn.setAttribute("data-quantity",qty);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    console.log('onKeyUp')
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if(summaryElement.hasAttribute('data-is-drawer-item')){
      summaryElement.closest('.mobile-facets__inner').classList.contains('drawer-open') ? this.closeMenuDrawer(summaryElement,false,true) : this.openMenuDrawer(summaryElement,true);
    }

    if (detailsElement === this.mainDetailsToggle) {
      
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
      console.log("iff")
    } else {
      console.log("else")
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(function() {
        console.log("inn")
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement,addParentNodeClass = false) {
//     console.log(this.mainDetailsToggle.classList,this.mainDetailsToggle);
    this.mainDetailsToggle.classList.add('menu-opening');
//     setTimeout(function() {this.mainDetailsToggle.classList.add('menu-opening');});
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    if(addParentNodeClass == true){
      summaryElement.closest('.mobile-facets__inner').classList.add('submenu--open');
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    // console.log('close')
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);

    }
  }

  onFocusOut(event) {
    if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
//     setTimeout(function(){
//       if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
//     });
  }

  onCloseButtonClick(event) {
    if(!event.currentTarget.classList.contains('disclosure__button')){
      if(event.currentTarget.parentElement.parentElement){
        event.currentTarget.parentElement.parentElement.classList.remove('submenu--open');
      }
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    // console.log('submenu')
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
//     console.log(detailsElement)

    if(detailsElement.closest('.mobile-facets__inner')){
      detailsElement.closest('.mobile-facets__inner').classList.remove('submenu--open');
    }

    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    var $this = this;
    setTimeout(function(){$this.mainDetailsToggle.classList.add('menu-opening')});
    //     setTimeout(function(){this.mainDetailsToggle.classList.add('menu-opening');});

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);
window.show = opener => {
  console.log("hiii", opener)
  this.openedBy = opener;
  document.body.classList.add('overflow-hidden');
  this.openedBy.setAttribute('open', '');
  if(this.openedBy.querySelector('.template-popup')){
    this.openedBy.querySelector('.template-popup').loadContent();
  }
  trapFocus(this.openedBy, this.openedBy.querySelector('[role="dialog"]'));
}
window.hide = (opener) => {
  this.closedBy =  this.openedBy;
  document.body.classList.remove('overflow-hidden');
  this.closedBy.removeAttribute('open');
  removeTrapFocus(this.openedBy);
  window.pauseAllMedia();
}
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', function() {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    console.log("hiii")
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if(this.querySelector('.template-popup')){
      this.querySelector('.template-popup').loadContent();
    }
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);
//console.log(this);
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if(button){
      button.addEventListener('click', function(){
        //console.log(show);
        // document.querySelector(this.getAttribute('data-modal'))?.show(button);
        window.show(document.querySelector(this.getAttribute('data-modal')));
        document.querySelector(this.getAttribute('data-modal')).querySelector('[id^="ModalClose-"]').addEventListener('click',window.hide);
      });
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if(this.querySelector('[id^="Deferred-Poster-"]')){
      this.querySelector('[id^="Deferred-Poster-"]').addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li.slider-component_slider');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    console.log('onButtonClick')
    console.log(this.sliderItems[0],'sliderItems')
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor(type) {
    super();
    console.log("Type :: ",this)
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    
    if(this.closest('[data-quickview-popup]') != null){
      this.currentVariant = false;
      this.renderQuickviewProductInfo(this.closest('[data-quickview-popup]'));
    }
//     this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
//     this.updateQuantitySelector();

    var submitBtn = this.closest('.product-main-wrapper').querySelector('button[type="submit"]');
    if(submitBtn){
      submitBtn.classList.add('disabled');
      submitBtn.setAttribute('disabled',true);
    }
    
    console.log(this)
    if (!this.currentVariant) {
      console.log('ifff')
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      console.log('else')
      this.toggleAddButton(true, '', true);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }
  
  /*updateQuantitySelector(){
    console.log(this.currentVariant.id,this.currentVariant,this)
    var selector = document.getElementById(`variant-quantity-selector--${this.currentVariant.id}`) ,
        qtySelectorHtml = selector.innerHTML,
        stock = selector.dataset.stock;
//     document.querySelector('[data-product-quantity]').outerHTML = qtySelectorHtml;
    document.querySelector(`[data-sticky-variant-dropdown="${this.currentVariant.id}"]`).click();
    document.querySelector('[data-sticky-add-to-cart]').classList.remove('open-sticky');
  }*/

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    var curMedia;
    if(this.currentVariant){
      curMedia = this.currentVariant.featured_media;
    }
    //     if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    if (!this.currentVariant || !curMedia) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(function(){ parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    var currentVariant;
    if(this.currentVariant){
      currentVariant = this.currentVariant;
    }
    if (this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    console.log('=====>>> ',`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      console.log(id,destination,source,html)
      
      document.querySelector('[data-buy-button-wrapper]').outerHTML = html.querySelector('[data-buy-button-wrapper]').outerHTML;

      var stickBtn = document.querySelector('button[type="button"].sticky-info-addToCart-button');
      stickBtn ? 
        (
        stickBtn.dataset.variantId = html.querySelector('button[type="button"].sticky-info-addToCart-button').dataset.variantId,
        stickBtn.dataset.quantity = html.querySelector('button[type="button"].sticky-info-addToCart-button').dataset.quantity
        )
      : false;

      if (source && destination) destination.innerHTML = source.innerHTML;

      if(document.getElementById(`price-${this.dataset.section}`)){
        document.getElementById(`price-${this.dataset.section}`).classList.remove('visibility-hidden');
      }
      // window.productQtySelectorLsitener()
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    });
  }
  
  renderQuickviewProductInfo(wrapper = null) {
    if(wrapper == null){
      return;
    }
    
    var variantId = this.querySelector('input[type="radio"]:checked').dataset.radioVariant;
    
    console.log('>>> ',`${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`)
    fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `#price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = wrapper.querySelector(id);
      const source = html.getElementById(id);
      console.log(id,destination,source,html)

      wrapper.querySelector('[data-buy-button-wrapper]').outerHTML = html.querySelector('[data-buy-button-wrapper]').outerHTML;

      var stickBtn = wrapper.querySelector('button[type="button"].sticky-info-addToCart-button');
      stickBtn ? 
        (
        stickBtn.dataset.variantId = html.querySelector('button[type="button"].sticky-info-addToCart-button').dataset.variantId,
        stickBtn.dataset.quantity = html.querySelector('button[type="button"].sticky-info-addToCart-button').dataset.quantity
      )
      : false;

      if (source && destination) destination.innerHTML = source.innerHTML;

      if(wrapper.querySelector(`#price-${this.dataset.section}`)){
        wrapper.querySelector(`#price-${this.dataset.section}`).classList.remove('visibility-hidden');
      }
      window.ella.attectEvents(wrapper);
      window.productQtySelectorLsitener()
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    });
  }
  

  toggleAddButton(disable = true, text, modifyClass = true) {
    let addButton;
    if(document.getElementById(`product-form-${this.dataset.section}`)){
      addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    }
    const formattedPrice = formatMoney(this.currentVariant.price, "{{ amount_with_comma_separator }} €");

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      
      //       if (text) addButton.textContent = text;
      addButton.innerHTML = `<span>${window.variantStrings.soldOut} &nbsp; &nbsp; | <price>${formattedPrice}</price></span>`;
    } else {
      addButton.removeAttribute('disabled');
      addButton.innerHTML = `<span>${window.variantStrings.addToCart} &nbsp; &nbsp; | <price>${formattedPrice}</price></span>`;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    let addButton;
    if(document.getElementById(`product-form-${this.dataset.section}`)){
      addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    }
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    if(document.getElementById(`price-${this.dataset.section}`)){
      document.getElementById(`price-${this.dataset.section}`).classList.add('visibility-hidden');
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
function formatMoney(cents, format = "{{amount_with_comma_separator}}") {

  if (typeof cents === "string") {

      cents = cents.replace(".", "");

  }

  

  cents = parseInt(cents, 10); // Ensure it's a number



  if (isNaN(cents) || cents == null) {

      return "0.00"; // Default fallback

  }



  let value = "";

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  const formatString = format || (typeof theme !== "undefined" ? theme.moneyFormat : "{{amount_with_comma_separator}}");



  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {

      number = (number / 100).toFixed(precision);

      const parts = number.split(".");

      const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);

      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;

  }



  const match = formatString.match(placeholderRegex);

  if (!match) {

      return formatWithDelimiters(cents, 2); // Default to amount format

  }



  switch (match[1]) {

      case "amount":

          value = formatWithDelimiters(cents, 2);

          break;

      case "amount_no_decimals":

          value = formatWithDelimiters(cents, 0);

          break;

      case "amount_with_comma_separator":

          value = formatWithDelimiters(cents, 2, ".", ",");

          break;

      case "amount_no_decimals_with_comma_separator":

          value = formatWithDelimiters(cents, 0, ".", ",");

          break;

      default:

          value = formatWithDelimiters(cents, 2); // Default fallback

  }



  return formatString.replace(placeholderRegex, value);

}